
export class UiUtil {

    /* Higher is redder */
    public static percentageColour(input: number) {
        const percent = Math.min(input, 1);
        const hue = Math.round(120 * (1 - percent));
        return `hsla(${hue}, 70%, 45%, 1)`;
    }

    /* Higher is greener */
    public static inversePercentageColour(input: number) {
        const percent = Math.min(input, 1);
        const hue = Math.round(120 * percent);
        return `hsla(${hue}, 70%, 45%, 1)`;
    }
}
